import React from "react";
import PropTypes from "prop-types";
import FollowupsListContainer from "../FollowupsListContainer/FollowupsListContainer";

const FollowupSection = ({
  sectionType,
  followups,
  isCompletedSection,
  handleClick,
  setFollowups,
  handleOpenFollowupAdd,
  isUsersOwnFollowups,
  showManagerReviews
}) => (
  <FollowupsListContainer
    followups={followups}
    handleClick={handleClick}
    handleOpenFollowupAdd={handleOpenFollowupAdd}
    isCompletedSection={isCompletedSection}
    isUsersOwnFollowups={isUsersOwnFollowups}
    sectionType={sectionType}
    setFollowups={setFollowups}
    showManagerReviews={showManagerReviews}
  />
);

FollowupSection.propTypes = {
  handleClick: PropTypes.func.isRequired,
  followups: PropTypes.array,
  sectionType: PropTypes.string,
  setFollowups: PropTypes.func.isRequired,
  isCompletedSection: PropTypes.bool,
  handleOpenFollowupAdd: PropTypes.func.isRequired,
  isUsersOwnFollowups: PropTypes.bool,
  showManagerReviews: PropTypes.bool
};

FollowupSection.defaultProps = {
  followups: [],
  sectionType: "",
  isCompletedSection: false,
  isUsersOwnFollowups: false,
  showManagerReviews: false
};

export default FollowupSection; 